import { Controller } from "@hotwired/stimulus"

// A contact card section that folds (contacts/_fold): Contact, Work, People &
// Relations, Notes, What you know, History, Sharing - and the task pane's
// sections the same way (task_panels/_section, keys "task-…"). Each starts open or folded as the server
// renders it, and the reader's own choice for a section is remembered in this
// browser - per section, not per contact, since "I never want History open"
// is a preference about the card.
//
// The choice is read off a click on the heading, not the toggle event: a
// <details open> fires toggle when it is parsed, so a toggle listener cannot
// tell the reader from the page.
const STORE = "emailpa-contact-sections"

export default class extends Controller {
    // empty: the task pane's empty sections start folded whatever was chosen
    // before (task_panels/_section).
    static values = { key: String, empty: Boolean }

    connect() {
        if (this.emptyValue) return
        const saved = this._saved()[this.keyValue]
        if (typeof saved === "boolean" && this.element.open !== saved) this.element.open = saved
    }

    chose(event) {
        // The heading's own ⋯ menu is not a fold.
        if (event?.target?.closest?.(".contact-fold-menu")) return

        const saved = this._saved()
        // The click runs before the browser flips it: the new state is the
        // opposite of now.
        saved[this.keyValue] = !this.element.open
        try {
            window.localStorage.setItem(STORE, JSON.stringify(saved))
        } catch (_error) {
            /* a private window still folds, it just forgets */
        }
    }

    _saved() {
        try {
            const saved = JSON.parse(window.localStorage.getItem(STORE) || "{}")
            return saved && typeof saved === "object" && !Array.isArray(saved) ? saved : {}
        } catch (_error) {
            return {}
        }
    }
}
